module.exports = __webpack_public_path__ + "img/anagramscramlogomain.044b2ab4.png";